import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';

var createLi = function createLi(item, index) {
  return React.createElement("li", {
    key: index
  }, React.createElement(Text, {
    small: true
  }, item));
};

var Details = function Details(_ref) {
  var title = _ref.title,
      review = _ref.review;
  return React.createElement("div", {
    className: "product-details-content"
  }, React.createElement("div", {
    key: title,
    className: "product-details-section"
  }, React.createElement(Text, {
    bold: true
  }, title), React.createElement("ul", null, (review || []).map(createLi))));
};

Details.propTypes = {
  title: PropTypes.string,
  review: PropTypes.array,
  icon: PropTypes.string
};
export default Details;